import { BASE_URL } from "../../constans/ApiEndpointConstants";
import * as PixelEventAPI from "../../apis/PixelEventAPI";
import LocalStorageUtil from "../../utils/localStorageUtil";

// 调用 addevent 接口
const url = BASE_URL.replace("https://", "");
const getAd = () => {
  const fromUtil = LocalStorageUtil.getAd?.();
  if (fromUtil) return fromUtil;
  const raw = localStorage.getItem("donation_ad");
  if (raw) {
    try {
      return JSON.parse(raw) || raw || "PurityBase";
    } catch {
      return raw || "PurityBase";
    }
  }
  return "shop";
};
const ad = getAd();

var addEvents = (eventName, eventid) => {
  PixelEventAPI.addevent(url, ad, eventName, eventid)
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const PixelWithEvent = (eventName, eventid) => {
  // 触发 ReactPixel 事件
  if (eventName !== "pageView") {
    addEvents(eventName, eventid);
  }
};
